import {
  withFormsy,
} from 'formsy-react';

import InputTextView from './InputTextView';

// @ts-expect-error form component
const InputComponent = withFormsy(InputTextView);

const Component = InputComponent;

export default Component;
